import { render, staticRenderFns } from "./CharacterCreatePage.vue?vue&type=template&id=8fd3de1c&scoped=true"
import script from "./CharacterCreatePage.vue?vue&type=script&lang=ts"
export * from "./CharacterCreatePage.vue?vue&type=script&lang=ts"
import style0 from "./CharacterCreatePage.vue?vue&type=style&index=0&id=8fd3de1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fd3de1c",
  null
  
)

export default component.exports